import HttpService from "./http.service";
import LocalStorageService from "./local.storage.service";
import CookieService from "./cookie.service";
import UtilsService from "./utils.service";
import PublicService from "./public";
import UserService from "./user.service";
import AndroidService from "./android.service.js";
// import * as echarts from "echarts";

/**
 * 工具类总入口
 * @param {*} Vue 实例
 */
export const DDDInit = (Vue) => {
  Vue.local = Vue.prototype.local$ = LocalStorageService;
  Vue.user = Vue.prototype.user$ = UserService;
  Vue.http = Vue.prototype.http$ = HttpService;
  Vue.cookie = Vue.prototype.cookie$ = CookieService;
  Vue.utils = Vue.prototype.utils$ = UtilsService;
  Vue.public = Vue.prototype.public$ = PublicService;
  // Vue.echarts = Vue.prototype.$echarts = echarts;
  Vue.android = Vue.prototype.android$ = AndroidService;
};
